"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var Chip_1 = require("../Chip");
var propTypes = {
    label: PropTypes.string,
    alignLabel: PropTypes.oneOf(['left', 'right', 'center']),
    accentColor: PropTypes.string,
    chipColor: PropTypes.string,
    labelColor: PropTypes.string,
    padding: PropTypes.oneOf(['small', 'normal', 'auto'])
};
/**
 * A `Card` is a container component which may have an optional label and will be
 * displayed as an UI card.
 */
var CardWithinContext = /** @class */ (function (_super) {
    __extends(CardWithinContext, _super);
    function CardWithinContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardWithinContext.prototype.render = function () {
        var _a, _b;
        var _c = this.props, children = _c.children, className = _c.className, label = _c.label, labelColor = _c.labelColor, alignLabel = _c.alignLabel, accentColor = _c.accentColor, chipColor = _c.chipColor, style = _c.style, padding = _c.padding, ergoElements = _c.ergoElements, other = __rest(_c, ["children", "className", "label", "labelColor", "alignLabel", "accentColor", "chipColor", "style", "padding", "ergoElements"]);
        var isDKVTheme = ergoElements.theme === 'dkv';
        var fallbackBackgroundColor = isDKVTheme ? '#88A327' : '#009284';
        var componentClassName = classNames('ee_card', (_a = {
                'ee_card--with-legend': Boolean(label)
            },
            _a["ee_card--" + padding + "-padding"] = Boolean(padding),
            _a), className);
        var extendedStyle = __assign({ borderColor: accentColor }, style);
        return (React.createElement("div", __assign({}, other, { role: "group", className: componentClassName, style: extendedStyle }),
            label && (React.createElement(Chip_1.default, { backgroundColor: chipColor || accentColor || fallbackBackgroundColor, textColor: labelColor, className: classNames('ee_card__legend', (_b = {},
                    _b["ee_card__legend--" + alignLabel] = Boolean(alignLabel),
                    _b)) }, label)),
            children));
    };
    CardWithinContext.propTypes = propTypes;
    CardWithinContext.defaultProps = {
        label: undefined,
        alignLabel: 'left',
        accentColor: undefined,
        chipColor: undefined,
        labelColor: undefined,
        padding: 'normal'
    };
    return CardWithinContext;
}(react_1.Component));
exports.CardWithinContext = CardWithinContext;
exports.default = CardWithinContext;
//# sourceMappingURL=CardWithinContext.js.map